import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Попробовать ещё раз ")

import { computed, watch } from "vue";
import { groupBy } from "lodash";

import { useAcsEvents } from "@/use/useAcsEvents";
import { useAsync } from "@/use/useAsync";
import { useStore } from "@/use/useStore";
import { formatDate } from "@/utils";

import UiSuspense from "@/plugins/ui/components/suspense/UiSuspense.vue";
import UiCard from "@/plugins/ui/components/card/UiCard.vue";
import UiHeader from "@/plugins/ui/components/header/UiHeader.vue";

import AcsEventCell from "./AcsEventCell.vue";
import UiPlaceholder from "@/plugins/ui/components/placeholder/UiPlaceholder.vue";
import UiBtn from "@/plugins/ui/components/button/UiBtn.vue";
import UiGroup from "@/plugins/ui/components/group/UiGroup.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'FullAcsEvents',
  setup(__props) {

const { currentUser } = useStore();
const { events, fetchAcsEvents } = useAcsEvents();

const fetchData = useAsync(() => fetchAcsEvents({ limit: "100" }), true);

const grouppedEvents = computed(() =>
  groupBy(events.value, (event) =>
    formatDate(event.date, { dateStyle: "long" })
  )
);

watch(() => currentUser.value?.id, fetchData.execute);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UiSuspense, {
    onRetry: _cache[1] || (_cache[1] = ($event: any) => (_unref(fetchData).execute())),
    pending: _unref(fetchData).isPending.value,
    failure: _unref(fetchData).isFailure.value,
    success: _unref(fetchData).isSuccess.value,
    variant: "screen",
    "has-retry": ""
  }, {
    default: _withCtx(() => [
      (_unref(events).length)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_unref(grouppedEvents), (events, date) => {
            return (_openBlock(), _createBlock(UiGroup, { key: date }, {
              header: _withCtx(() => [
                _createVNode(UiHeader, { title: date }, null, 8, ["title"])
              ]),
              default: _withCtx(() => [
                _createVNode(UiCard, null, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(events, (event) => {
                      return (_openBlock(), _createBlock(AcsEventCell, {
                        key: event.id,
                        event: event
                      }, null, 8, ["event"]))
                    }), 128))
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024))
          }), 128))
        : (_openBlock(), _createBlock(UiPlaceholder, {
            key: 1,
            icon: "EmojiSad",
            title: "Событий СКУД не найдено",
            description: "К сожалению, событий о проходе ребенка в учреждение не найдено."
          }, {
            action: _withCtx(() => [
              _createVNode(UiBtn, {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(fetchData).execute())),
                variant: "secondary"
              }, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
    ]),
    _: 1
  }, 8, ["pending", "failure", "success"]))
}
}

})